module.exports = __webpack_public_path__ + "img/9788995516409.bf6584d9.jpg";